module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACySURBVDiNtZJBEcIwFEQ3DAIqAQfUATjAQiWAgkpAQgcFSGBQUBy0DoKDx4EUMm34TQ/sMcm++fs30j8EFMAZaIEOqIFiCaBlqi7XfEyYB1Xj96sEY2vwdzmA3gA8jbu3gI0RYT8LCJAK8JHRp/JLkvs1haRS0iGM/ZB0d85Z8T79N0aEG1BagFT/Y/kw4cRs9T9WkwJcFwAYfPE/yP/r30VrHZ2dJNVh+5Z6SZfZRnL1Av41PnptBjo+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.png
// module id = Gvv4
// module chunks = 1